<template>
  <form
    class="fff-modal date-modal"
    @submit.prevent="submit"
  >
    <div
      class="overlay"
      @click="hide"
    />
    <div class="box">
      <div
        class="close-modal"
        @click="hide"
      >
        &times;
      </div>
      <input
        ref="date_input"
        v-model="date"
        type="hidden"
      >
      <input
        ref="date_type"
        v-model="type"
        type="hidden"
      >
      <div class="field">
        <div
          v-if="hidenav!='hide'"
          class="food-navbar"
        >
          <a
            class="item"
            :class="{on: type == 'day'}"
            @click="set_type('day')"
          >Day</a>
          <a
            class="item"
            :class="{on: type == 'week'}"
            @click="set_type('week')"
          >Week</a>
          <a
            class="item"
            :class="{on: type == 'month'}"
            @click="set_type('month')"
          >Month</a>
        </div>
      </div>
      <div class="field">
        <datepicker
          ref="date_picker"
          :inline="true"
          :value="date_parsed"
          :minimum-view="minimum_view"
          format="YYYY-MM-dd"
          :highlighted="{ dates: [ (new Date()) ] }"
          @input="submit"
        />
      </div>
    </div>
  </form>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  props: {
    thedate:{},
    thetype: {
      type: String,
      default: 'day',
    },
    hidenav:{
      default:'show',
      type:String
    },
    theinput:String
  },
  data () {
    return {
      type: 'day',
      minimum_view: 'day',
      date: {
        type: String,
        default: (new Date()).toISOString().split('T')[0],
      },
    }
  },
  computed: {
    date_simple() {
      return moment(this.date).format('YYYY-MM-DD');
    },
    date_parsed() {
      return moment(this.date).toDate();
    },
  },
  watch: {
    'thedate': function (s) {
      this.set_date();
    },
    'thetype': function (newValue) {
      this.set_type(newValue);
    },
  },
  mounted(){
    this.set_date();
    this.set_type(this.thetype);
  },
  methods: {
    hide() {
      this.$emit('hide-modal');
    },
    submit(dateval) {
      this.date = dateval;
      this.$emit('choose-date', this.date_simple);
      this.$emit('choose-type', this.type);
      if(this.theinput!=''){
        this.$emit('choose-input', {'elementname':this.theinput,'date':this.date_simple});
      }
      this.hide();
    },
    set_type(type) {
      this.type = type;
      this.$emit('choose-type', this.type);
      if (type == 'day') {
        this.minimum_view = 'day';
        this.$refs.date_picker.showDayView = true;
        this.$refs.date_picker.showMonthView = false;
        this.$refs.date_picker.showYearView = false;
      } else if (type == 'week') {
        this.minimum_view = 'day';
        this.$refs.date_picker.showDayView = true;
        this.$refs.date_picker.showMonthView = false;
        this.$refs.date_picker.showYearView = false;
      } else if (type == 'month') {
        this.minimum_view = 'month';
        this.$refs.date_picker.showDayView = false;
        this.$refs.date_picker.showMonthView = true;
        this.$refs.date_picker.showYearView = false;
      }
    },
    set_date(){
      this.date = this.thedate;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>